// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Log the API URL to help with debugging
console.log('Configured API Base URL:', API_BASE_URL);

/**
 * Helper function to create API URLs consistently
 * @param path The API path (without leading slash)
 * @returns The full API URL
 */
export const getApiUrl = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  // Ensure the base URL doesn't end with a slash
  const baseUrl = API_BASE_URL.endsWith('/') 
    ? API_BASE_URL.slice(0, -1) 
    : API_BASE_URL;
    
  return `${baseUrl}/${cleanPath}`;
};

// Add other configuration constants as needed 
